import review42 from "../../assets/images/reviews/r1.jpg";
import review41 from "../../assets/images/reviews/r2.jpg";
import review40 from "../../assets/images/reviews/r3.jpg";
import review39 from "../../assets/images/reviews/r4.jpg";
import review38 from "../../assets/images/reviews/r5.jpg";
import review37 from "../../assets/images/reviews/r6.jpg";
import review36 from "../../assets/images/reviews/r7.jpg";
import review35 from "../../assets/images/reviews/r8.jpg";
import review34 from "../../assets/images/reviews/r9.jpg";
import review33 from "../../assets/images/reviews/r10.jpg";
import review32 from "../../assets/images/reviews/r11.jpg";
import review31 from "../../assets/images/reviews/r12.jpg";
import review30 from "../../assets/images/reviews/r13.jpg";
import review29 from "../../assets/images/reviews/r14.jpg";
import review28 from "../../assets/images/reviews/r15.jpg";
import review27 from "../../assets/images/reviews/r16.jpg";
import review26 from "../../assets/images/reviews/r17.jpg";
import review25 from "../../assets/images/reviews/r18.jpg";
import review24 from "../../assets/images/reviews/r19.jpg";
import review23 from "../../assets/images/reviews/r20.jpg";
import review22 from "../../assets/images/reviews/r21.jpg";
import review21 from "../../assets/images/reviews/r22.jpg";
import review20 from "../../assets/images/reviews/r23.jpg";
import review19 from "../../assets/images/reviews/r24.jpg";
import review18 from "../../assets/images/reviews/r25.jpg";
import review17 from "../../assets/images/reviews/r26.jpg";
import review16 from "../../assets/images/reviews/r27.jpg";
import review15 from "../../assets/images/reviews/r28.jpg";
import review14 from "../../assets/images/reviews/r29.jpg";
import review13 from "../../assets/images/reviews/r30.jpg";
import review12 from "../../assets/images/reviews/r31.jpg";
import review11 from "../../assets/images/reviews/r32.jpg";
import review10 from "../../assets/images/reviews/r33.jpg";
import review9 from "../../assets/images/reviews/r34.jpg";
import review8 from "../../assets/images/reviews/r35.jpg";
import review7 from "../../assets/images/reviews/r36.jpg";
import review6 from "../../assets/images/reviews/r37.jpg";
import review5 from "../../assets/images/reviews/r38.jpg";
import review4 from "../../assets/images/reviews/r39.jpg";
import review3 from "../../assets/images/reviews/r40.jpg";
import review2 from "../../assets/images/reviews/r41.jpg";
import review1 from "../../assets/images/reviews/r42.jpg";

export const reviewsData = [
  {
    id: 1,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review1,
  },
  {
    id: 2,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review2,
  },
  {
    id: 3,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review3,
  },
  {
    id: 4,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review4,
  },
  {
    id: 5,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review5,
  },
  {
    id: 6,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review6,
  },
  {
    id: 7,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review7,
  },
  {
    id: 8,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review8,
  },
  {
    id: 9,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review9,
  },
  {
    id: 10,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review10,
  },
  {
    id: 11,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review11,
  },
  {
    id: 12,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review12,
  },
  {
    id: 13,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review13,
  },
  {
    id: 14,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review14,
  },
  {
    id: 15,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review15,
  },
  {
    id: 16,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review16,
  },
  {
    id: 17,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review17,
  },
  {
    id: 18,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review18,
  },
  {
    id: 19,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review19,
  },
  {
    id: 20,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review20,
  },
  {
    id: 21,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review21,
  },
  {
    id: 22,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review22,
  },
  {
    id: 23,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review23,
  },
  {
    id: 24,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review24,
  },
  {
    id: 25,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review25,
  },
  {
    id: 26,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review26,
  },
  {
    id: 27,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review27,
  },
  {
    id: 28,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review28,
  },
  {
    id: 29,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review29,
  },
  {
    id: 30,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review30,
  },
  {
    id: 31,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review31,
  },
  {
    id: 32,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review32,
  },
  {
    id: 33,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review33,
  },
  {
    id: 34,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review34,
  },
  {
    id: 35,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review35,
  },
  {
    id: 36,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review36,
  },
  {
    id: 37,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review37,
  },
  {
    id: 38,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review38,
  },
  {
    id: 39,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review39,
  },
  {
    id: 40,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review40,
  },
  {
    id: 41,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review41,
  },
  {
    id: 42,
    name: "Nur Alam",
    rating: 5,
    review: "",
    img: review42,
  },
];
